import React from 'react';
import { BlockContext, useSlate, useSlateKitContext } from '../hooks/index.js';
import { getBlockProps } from '../utils/index.js';
import { ErrorBoundary } from './ErrorBoundary.js';
import { withSSRErrorHandler } from './withSSRErrorHandler.js';
const renderBlock = (options) => {
    const { slate, compiledSlate, block, context, Wrapper, onError, ErrorFallback, } = options;
    const { id, children = [], Component } = block;
    const onRenderError = (error, errorInfo) => onError &&
        onError({
            error,
            errorInfo,
            block,
            compiledSlate,
            context,
            slate,
        });
    const SSRErrorPruneComponent = withSSRErrorHandler(Component, onRenderError);
    const childrenBlocks = children
        .filter(childId => { var _a; return !((_a = compiledSlate.blocks[childId]) === null || _a === void 0 ? void 0 : _a.config.hide); })
        .map(childId => React.createElement(BlockRenderer, { key: childId, id: childId }));
    const renderedBlock = (React.createElement(SSRErrorPruneComponent, Object.assign({ key: id }, block.compiledProps), childrenBlocks));
    return (React.createElement(ErrorBoundary, { ErrorFallback: ErrorFallback, onError: onRenderError }, Wrapper ? (React.createElement(Wrapper, { key: id, Block: SSRErrorPruneComponent, childrenBlocks: childrenBlocks }, renderedBlock)) : (renderedBlock)));
};
export const BlockRenderer = ({ id: blockId }) => {
    const { kit, onError, ErrorFallback } = useSlateKitContext();
    const slateProps = useSlate();
    const { slate, compiledSlate, context } = slateProps;
    const block = compiledSlate.blocks[blockId];
    if (!block || block.config.hide)
        return null;
    if (!kit.isBlockRegistered(block.name))
        return null;
    const renderedBlock = renderBlock({
        slate,
        compiledSlate,
        block,
        context,
        Wrapper: kit.loadBlockWrapper(),
        onError,
        ErrorFallback,
    });
    return renderedBlock ? (React.createElement(BlockContext.Provider, { key: blockId, value: getBlockProps(blockId, slateProps) }, renderedBlock)) : null;
};
//# sourceMappingURL=BlockRenderer.component.js.map